import React, { Fragment, useEffect } from "react";
import { useSelector } from "react-redux";
import useCountdownTimer from "../hooks/useCountdownTimer";
import { AUCTION_STATUS } from "../../utils/constants";
import { getPropertyStatus } from "../../helpers";
import useTranslationHook from "../hooks/useTranslationHook";
import { guessDateTime } from "../../utils/dateUtils";
function CardTimer({ data, onStatusChange, isLiveCard = false, useLongLabel = false, view, layout }) {
    const start_date = data?.start_date;
    const end_date = data?.end_date;
    const lang = useSelector((state) => state.translation.lang);
    const isListingActive = Number(data?.listing_status_id ?? 0) === 1;
    const { t } = useTranslationHook();
    const isSeller = useSelector((state) => state.profile.account);
    const { status, days, hours, minutes, seconds } = useCountdownTimer(
        isListingActive ? start_date : 0,
        isListingActive ? end_date : 0
    );

    const timer = React.useMemo(() => [
        {
            value: String(days).padStart(2, "0"),
            label: isLiveCard ? "Days" : useLongLabel ? "Days" : "d",
        },
        {
            value: String(hours).padStart(2, "0"),
            label: isLiveCard ? "Hours" : useLongLabel ? "Hours" : "h",
        },
        {
            value: String(minutes).padStart(2, "0"),
            label: isLiveCard ? "Minutes" : useLongLabel ? "Mins" : "m",
        },
        {
            value: String(seconds).padStart(2, "0"),
            label: isLiveCard ? "Seconds" : useLongLabel ? "Secs" : "s",
        },
    ], [days, hours, minutes, seconds, isLiveCard, useLongLabel]);
    const filteredTimer = React.useMemo(
        () => (days > 0 ? timer.slice(0, 3) : timer.slice(1)),
        [days, timer]
    );
    const { label, value } = AUCTION_STATUS[status];
    const prevStatusRef = React.useRef();
    const isDiscover =
        view === "grid" &&
        layout === "calendar" &&
        label === "Ends In";

    useEffect(() => {
        if (!onStatusChange) return;

        const totalSeconds =
            days * 86400 + hours * 3600 + minutes * 60 + seconds;

        const safeSeconds = totalSeconds <= 0 ? -1 : totalSeconds;

        let start_time = 0;
        let end_left = 0;

        if (status === "not_started" || status === "coming_soon") {
            start_time = safeSeconds;
        } else if (status === "running" || status === "nearby_to_close") {
            end_left = safeSeconds;
        } else {
            end_left = -1;
        }

        const newStatus = isLiveCard
            ? value
            : getPropertyStatus(
                data?.listing_status_id,
                start_time,
                end_left,
                data?.reserve_amount <= data?.high_bid_amt,
                isSeller,
                true
            );

        onStatusChange(newStatus);

    }, [
        status,
        days,
        hours,
        minutes,
        seconds,
        isSeller,
        data?.listing_status_id,
        data?.high_bid_amt,
        data?.reserve_amount
    ]);

    if (value === 3) {
        return (
            <div className="timer discover">
                <small>{t("Closed On")}</small>
                <h6 className="time">
                    {`${guessDateTime(end_date, "D, MMM YYYY", 0, lang)}`}
                </h6>
            </div>
        );
    }

    return (
        <div className={`timer ${isDiscover ? "discover" : ""}`}>
            <small>{t(label)}</small>
            {isLiveCard ? (
                <ol>
                    {filteredTimer.map((item, index) => (
                        <React.Fragment key={index}>
                            <li>
                                <h5>
                                    {(item.value)}
                                    <span>{t(item.label)}</span>
                                </h5>
                            </li>
                        </React.Fragment>
                    ))}
                </ol>
            ) : (
                <h6 className="time">
                    {filteredTimer.map((item, index) => (
                        <React.Fragment key={index}>
                            <span>
                                {useLongLabel ? (
                                    <Fragment>
                                        {(item.value)}
                                        <em>{t(item.label)}</em>
                                    </Fragment>
                                ) : (
                                    t(
                                        {
                                            d: "days",
                                            h: "hours",
                                            m: "minutes",
                                            s: "seconds",
                                        }[item.label],
                                        {
                                            ["days"]: item.value,
                                            ["hours"]: item.value,
                                            ["minutes"]: item.value,
                                            ["seconds"]: item.value
                                        }
                                    )
                                )}
                            </span>

                            {index < (filteredTimer.length - 1) && ":"}
                        </React.Fragment>
                    ))}
                </h6>
            )}
        </div>
    );
}

export default React.memo(CardTimer);
